<template>
  <div class="code-input-page">
    <!-- ヘッダー -->
    <TheHeader :headerTitle="masterSheet.name" />

    <div class="passcode__wrapper">
      <!-- コード入力コンポーネント -->
      <TheSheetEmergencyCode0-9ButtonForm
        :multiSheetValidIdsArray="props.multiSheetValidIdsArray"
        @open-dialog="openDialog"
        @error-handring="errorHandring"
      />
    </div>

    <TheSheetEmergencyCodeDialogs :openedDialogName="openedDialogName" />
  </div>
</template>

<script>
// Vue
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "TemplateSheetEmergencyCode",
  props: {
    multiSheetValidIdsArray: {
      type: Array,
    },
  },
  components: {},
  setup(props) {
    const store = useStore();

    const openedDialogName = ref("");

    const errorHandring = (err) => {
      console.log("err errorHandring!!!:>> ", err);

      if (err == "valid_error_already_validated_another") {
        // PUT /books/:id/is_valid の同時利用エラーが valid_error_already_validated_another
        openDialog("DialogAlreadyValidatedAnother");
      } else if (err == "max_concurrent_using_over") {
        // POST /valid_books  の同時利用エラーが max_concurrent_using_over
        openDialog("DialogMaxConcurrentUsingOver");
      } else if (err == "invalid_use_interval") {
        // PUT /emergency_code?code=xxxxxx にてUseInterval内のため使用不可ダイアログ
        openDialog("DialogInvalidUseInterval");
      } else if (err == "not_emergency_code") {
        // PUT/emergency_code?code=xxxxxx にて emergency_codeが間違えている
        openDialog("DialogValidFramesWithEmergencyCodeFails");
      } else {
        // それ以外の理由でのデフォルトエラー
        openDialog("DialogValidFramesWithEmergencyCodeFails");
      }
    };

    const openDialog = (dialogName) => {
      openedDialogName.value = dialogName;
    };

    const masterSheet = computed(() => store.getters["ticketing/masterSheet"]);

    return {
      masterSheet,
      openedDialogName,
      openDialog,
      errorHandring,
      props,
    };
  },
};
</script>

<style lang="scss" scoped>
.code-input-page {
  background: linear-gradient(#fcca09, #fde265);
  height: 100vh;
  width: 100vw;
}
</style>
